<template>
  <div class="area-graph show-labels" ref="graph">
    <div class="block" :style="style" ref="block">
      <label class="tx-page-subtitle tx-wg-bold">{{ item.label }}</label>
    </div>
  </div>
</template>

<script>
import * as scale from 'd3-scale';
import gsap from 'gsap';
import CustomEase from '@/vendor/gsap/CustomEase.min';
import CustomBounce from '@/vendor/gsap/CustomBounce.min';
gsap.registerPlugin(CustomEase, CustomBounce);

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    max: {
      type: Number,
      required: true
    },
    min: {
      type: Number,
      required: true
    },
    tilt: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      style: {}
    };
  },
  mounted() {
    this.style = this.getBlockStyle();
    gsap.set(this.$refs.block, { y: -window.innerHeight * 1.1 });
  },
  methods: {
    next() {
      const ease = CustomBounce.create('custom-bounce', {
        strength: 0.1,
        squash: 0.1,
        squashID: 'custom-bounce-squash'
      });
      gsap.to(this.$refs.block, 2, {
        y: 0,
        ease
      });
    },
    getBlockStyle() {
      const bounds = this.$refs.graph.getBoundingClientRect();
      const dataScale = scale.scaleLinear().domain([this.min, this.max]);
      dataScale.range([Math.pow(this.min, this.tilt), this.max]);
      const blockScale = scale.scaleLinear().domain([this.min, this.max]);
      blockScale.range([0, bounds.width * 0.9]);
      const w = blockScale(dataScale(this.item.value));
      const h = w * 1.4;
      return { 'background-color': this.item.color, width: `${w}px`, height: `${h}px` };
    }
  }
};
</script>

<style lang="scss">
.area-graph {
  .block {
    top: auto;
    left: auto;
    right: 0;
    bottom: 0;
  }
}
</style>
